import { PlanComparison } from '@/datas/plan-comparison';
import { t } from '@/plugins/i18n';
import { showDialog } from '../utils/export';
import { ZOOM_ONE_EDU_PLAN_DETAIL_PAGE_ID } from '@/datas/ZoomOneEdu';
import { PLAN_TYPES } from '@/components/PLAN_LEARN_MORE_DIALOG/utils';
import { BADGE_ID_MAPPER } from '@/datas/auto-expire-badge';

export class ZoomOneEduComparison extends PlanComparison {
  constructor(props = {}) {
    super(props);
  }
  buildTree() {
    this.treeData = tableDataGetter(this.props);
    return this;
  }
}

const tableDataGetter = (props)=> {
  return schoolDataGetter(props)
}

const schoolDataGetter = ({ largeMeetingConfig, enableDocsFeature, enableDisplayZoomWorkFlow, enableDisplayZoomDrive, showDocsLearnMore, DocsCallBack, enableDisplayZoomTasksWithoutAccountCheck, showTasksLearnMore, tasksEventTracking, aiCompanionEventTracking, appName, showCampusScheduler, customAvatarEventTracking, showCustomAvatarLearnMore, isEligibleAccount4CustomAvatarFeature, enableEduWorkspaceReservations }) =>  ([
  // license count
  {
    feature: t('meetings.fullPlanItem2'),
    tooltip: t('meetings.fullPlanItem2Tip'),
    school: '20-250',
    schoolPlus: '20-250',
    enterPrise: "100+ K-12*<br>250+ HED**"
  },
  // zoom meetings
  {
    feature: t('phone.fullPlanItem30'),
    tooltip: t('simplifiedVideoConferencingAndMessagingAcrossAnyDevice'),
    school: true,
    schoolPlus: true,
    enterPrise: true
  },
  // Meeting duration
  {
    feature: t('meetings.fullPlanItem5'),
    tooltip: t('meetings.fullPlanItem5Tip'),
    school: t('meetings.fullPlanItem5_pro'),
    schoolPlus: t('meetings.fullPlanItem5_pro'),
    enterPrise: t('meetings.fullPlanItem5_pro'),
  },
  // Participants capacity
  {
    feature: t('meetings.fullPlanItem1'),
    tooltip: t('meetings.fullPlanItem1Tip'),
    school: {
      text: '300',
      callback: largeMeetingConfig['school']?.callback,
      disabled: largeMeetingConfig['school']?.disabled,
      link: !largeMeetingConfig['school']?.display ? '' : largeMeetingConfig['school']?.disabled ?
        t('common.participant_limit.expandable_with_large_meetings') :
        t('common.participant_limit.increase_with_large_meetings'),
      linkClass: 'manual-open-large-meeting'
    },
    schoolPlus: {
      text: '300',
      callback: largeMeetingConfig['schoolPlus']?.callback,
      disabled: largeMeetingConfig['schoolPlus']?.disabled,
      link: !largeMeetingConfig['schoolPlus']?.display ? '' : largeMeetingConfig['schoolPlus']?.disabled ?
        t('common.participant_limit.expandable_with_large_meetings') :
        t('common.participant_limit.increase_with_large_meetings'),
      linkClass: 'manual-open-large-meeting-plus'
    },
    enterPrise: t('common.plans.meeting.enterprise')
  },
  // workflow
  {
    feature: t('billing.plan.feature.workflow.title'),
    tooltip: t('billing.plan.feature.workflow.tip'),
    shouldHide: !enableDisplayZoomWorkFlow,
    badgeId: BADGE_ID_MAPPER.WORKFLOW_AUTOMATION,
    link: {
      text: t('common.learnMore'),
      hasLearnMore: true,
      style: {
        fontSize: '12px',
        fontWeight: 700,
        color: '#0B5CFF'
      },
      ariaLabel: 'Learn more about WorkFlow Automation',
      callback: async ()=> showDialog(await import(/* webpackChunkName: "zoom_work_flow_automation_dialog" */ '@/components/ZOOM_WORK_FLOW_AUTOMATION_DIALOG'), { visible: true })
    },
    school: t('billing.plan.feature.workflow.label'),
    schoolPlus: t('billing.plan.feature.workflow.label'),
    enterPrise: t('billing.plan.feature.workflow.label')
  },
  // drive
  {
    feature: t('billing.plan.feature.drive.title'),
    tooltip: t('billing.plan.feature.drive.tip'),
    shouldHide: !enableDisplayZoomDrive,
    badgeId: BADGE_ID_MAPPER.DRIVE,
    link: {
      text: t('common.learnMore'),
      hasLearnMore: true,
      style: {
        fontSize: '12px',
        fontWeight: 700,
        color: '#0B5CFF'
      },
      ariaLabel: 'Learn more about Zoom Hub',
      callback: async ()=> showDialog(await import(/* webpackChunkName: "PLAN_LEARN_MORE_DIALOG" */ '@/components/PLAN_LEARN_MORE_DIALOG'), { visible: true, planType: PLAN_TYPES.DRIVE })
    },
    school: true,
    schoolPlus: true,
    enterPrise: true
  },
  // auto meetings captions
  {
    feature: t('automatedMeetingsCaptions'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // translated captions
  {
    feature: t('one.translatedCations'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // recording transcript
  {
    feature: t('meetings.fullPlanItem33'),
    tooltip: t('meetings.fullPlanItem33Tip'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // cloud storage
  {
    feature: t('cloudStorage'),
    tooltip: t('backChannelsToTheZoomCloudOrAThirdPartyStorageProvider'),
    school: t('detail_dialog.meeting_feature.cloud_recording.pro'),
    schoolPlus: t('detail_dialog.meeting_feature.cloud_recording.10'),
    enterPrise: {
      text: t('detail_dialog.meeting_feature.cloud_recording.10'),
      extra: t('detail_dialog.meeting_feature.cloud_recording.ent')
    },
  },
  // admin portal
  {
    feature: t('meetings.fullPlanItem31'),
    tooltip: t('meetings.fullPlanItem31Tip'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // lti integration
  {
    feature: t('meetings.fullPlanItem32'),
    tooltip: t('meetings.fullPlanItem32Tip'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // end encryption
  {
    feature: t('endToEndEncryptionForZoomMeetings'),
    tooltip: t('whenEnabledZoomsEndToEndEncryptionE2eeForZoomMeetings',),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // zoom c m k
  {
    feature: t('zoomCustomerManagedKey'),
    tooltip: t('bringYourOwnEncryptionKeysToProtectZoomDataAtRest'),
    school: false,
    schoolPlus: false,
    enterPrise: false,
  },
  // enter grade security
  {
    feature: t('enterpriseGradeSecurityFeatures'),
    tooltip: t('256BitAesGcmEncryptionForRealTimeContent'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // team chat
  {
    feature: t('one.messaging'),
    tooltip: t('meetings.fullPlanItem16Tip'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // zoom room and CRC
  {
    feature: t('plans.zr_crc'),
    school: false,
    schoolPlus: false,
    enterPrise: t('plans.zr_crc.ent'),
  },
  // zoom webinar
  {
    feature: t('plans.webinar'),
    school: false,
    schoolPlus: false,
    enterPrise: {
      text: 'Webinar 500',
      extra: t('plans.webinar.ent')
    },
  },
  // zoom whiteboards
  {
    feature: t('meetings.fullPlanItem51'),
    school: t('meetings.unlimited'),
    schoolPlus: t('meetings.unlimited'),
    enterPrise: {
      text: t('meetings.unlimited'),
      extra:t('plans.whiteboard.ent')
    }
  },
  // mail
  {
    feature: t('mail'),
    tooltip: t('zoomMailAndCalendarInTheZoomApp'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // mail service
  {
    feature: t('mailService'),
    tooltip: t('emailServiceWithFullTimeEndToEnd'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // customer mail domain
  {
    feature: t('customMailDomain'),
    tooltip: t('customMailDomainWithMailService'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // AI
  {
    feature: t('aiCompanion'),
    link: {
      text: t('common.learnMore'),
      hasLearnMore: true,
      style: {
        fontSize: '12px',
        fontWeight: 700,
        color: '#0B5CFF'
      },
      ariaLabel: 'Learn more about AI Companion',
      callback: async ()=> showDialog(await import(/* webpackChunkName: "ai_companion_dialog" */ '@/components/AI_COMPANION_DIALOG'), { visible: true }, aiCompanionEventTracking)
    },
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // calendar client
  {
    feature: t('calendarClient'),
    tooltip: t('scheduleAndJoinMeetings'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // calendar service
  {
    feature: t('calendarService'),
    tooltip: t('meetingSchedulingAndAppointment'),
    school: true,
    schoolPlus: true,
    enterPrise: true,
  },
  // zoom phone
  {
    feature: t('common.phoneTab'),
    school: false,
    schoolPlus: true,
    enterPrise: {
      extra: t('plans.zp.ent')
    },
  },
  {
    feature: t('fbc.plan_details.biz_plus.docs.docs'),
    tooltip: t('fbc.plan_details.biz_plus.docs.comparison_table_tips'),
    shouldHide: !enableDocsFeature,
    school: t('meetings.unlimited'),
    schoolPlus: t('meetings.unlimited'),
    enterPrise: t('meetings.unlimited'),
    link: showDocsLearnMore ? {
      classname: 'manual-open-docs-dialog',
      text: t('common.learnMore'),
      hasLearnMore: true,
      style: {
        fontSize: '12px',
        fontWeight: 700,
        color: '#0B5CFF',
      },
      ariaLabel: 'Learn more about Zoom Docs',
      async callback() {
        await DocsCallBack && DocsCallBack();
      }
    } : null
  },
  {
    feature: t('fbc.plan_details.biz_plus.tasks.tasks'),
    tooltip: t('fbc.plan_details.biz_plus.tasks.comparison_table_tips'),
    shouldHide: !enableDisplayZoomTasksWithoutAccountCheck,
    badgeId: BADGE_ID_MAPPER.TASKS,
    school: true,
    schoolPlus: true,
    enterPrise: true,
    link: showTasksLearnMore ? {
      classname: 'manual-open-tasks-dialog',
      text: t('common.learnMore'),
      style: {
        fontSize: '12px',
        fontWeight: 700,
        color: '#0B5CFF',
      },
      ariaLabel: 'Learn more about Zoom Tasks',
      callback: async ()=> showDialog(await import(/* webpackChunkName: "tasks_dialog" */ '@/components/TASKS_DIALOG'), { visible: true }, tasksEventTracking)
    } : null
  },
  // unlimited calling
  {
    feature: t('phone.fullPlanItem1'),
    school: false,
    schoolPlus: true,
    enterPrise: {
      extra: t('plans.zp.ent')
    },
  },
  // workspace reservation
  {
    feature: t('workspaceReservation'),
    school: enableEduWorkspaceReservations,
    schoolPlus: true,
    enterPrise: true,
  },
  // clips
  {
    feature: appName === 'pricing' ? `${t('marketing.new_pricing.clips')}***` : t('marketing.new_pricing.clips'),
    school: t('meetings.unlimited'),
    schoolPlus: t('meetings.unlimited'),
    enterPrise: t('meetings.unlimited')
  },
  {
    feature: t('fbc.plan_details.custom_avatar.title'),
    tooltip: t('fbc.plan_details.custom_avatar.comparison_table_tips'),
    shouldHide: !isEligibleAccount4CustomAvatarFeature,
    badgeId: BADGE_ID_MAPPER.CUSTOM_AVATAR,
    school: t('fbc.plan_details.custom_avatar.pricing_feature'),
    schoolPlus: t('fbc.plan_details.custom_avatar.pricing_feature'),
    enterPrise: t('fbc.plan_details.custom_avatar.pricing_feature'),
    link: showCustomAvatarLearnMore ? {
      classname: 'manual-open-custom-avatar-dialog',
      text: t('common.learnMore'),
      style: {
        fontSize: '12px',
        fontWeight: 700,
        color: '#0B5CFF',
      },
      ariaLabel: 'Learn more about Custom Avatars',
      callback: async ()=> showDialog(await import(/* webpackChunkName: "plan_learn_more_dialog" */ '@/components/PLAN_LEARN_MORE_DIALOG'), { visible: true, planType: PLAN_TYPES.CUSTOM_AVATAR }, customAvatarEventTracking)
    }: null
  },
  // zoom scheduler
  {
    feature: t('plans.zoom_scheduler.title'),
    school: !!showCampusScheduler,
    schoolPlus: true,
    enterPrise: showCampusScheduler ? true : {
      extra: t('plans.zp.ent')
    },
  },
  // access across any device
  {
    feature: t('accessAcrossAnyDevice'),
    school: true,
    schoolPlus: true,
    enterPrise: true
  },
].filter(item => {
  return item.shouldHide !== true;
}))

export const defaultColConfig = [
  {
    title: t('zoom_one_edu_bundle.school.brief_title'),
    key: ZOOM_ONE_EDU_PLAN_DETAIL_PAGE_ID.SCHOOL,
    btn: null
  },
  {
    title: t('zoom_one_edu_bundle.school_plus.brief_title'),
    key: ZOOM_ONE_EDU_PLAN_DETAIL_PAGE_ID.SCHOOL_PLUS,
    btn: null
  }

]

export const largeMeetingDisabledConfig = {
  school: {
    callback: () => {},
    disabled: false,
    display: true
  },
  schoolPlus: {
    callback: () => {},
    disabled: false,
    display: true
  },
}
